import { Fragment } from 'react'
import NextLink from 'next/link'
import { Grid, Text, Link } from '@chakra-ui/layout'

import { List } from '../components/shared'

export const REFERRAL_TERMS: TermsItem = {
  title: 'ข้อกำหนดและเงื่อนไขกิจกรรมการแนะนำผู้ซื้อรายใหม่',
  checkActive: ['referralTerms'],
  linkTo: 'referralTerms',
  subMenus: [
    {
      title: 'ขอบเขตของข้อกำหนดและเงื่อนไข',
      scrollTo: 'term-and-condition-boundary',
      content: (
        <Fragment>
          <p>
            กิจกรรมการแนะนำนี้มีขึ้นเพื่อให้ผู้ที่สนใจในกิจกรรมการแนะนำได้นำรหัสผู้แนะนำที่ได้จากการสมัครเข้าร่วมกิจกรรมไปให้ลูกค้ารายใหม่ที่ยังไม่เคยมีการสั่งซื้อสินค้าหรือบริการกับบริษัททำการกรอกรหัสผู้แนะนำในขั้นตอนการชำระเงินเพื่อแลกกับค่าตอบแทนจากการแนะนำดังกล่าวและลูกค้ารายใหม่ที่ใช้รหัสผู้แนะนำของผู้แนะนำจะได้ส่วนลดเมื่อซื้อสินค้าหรือบริการกับบริษัทเป็นครั้งแรก
          </p>
          <p>
            ในการเข้าร่วมกิจกรรมการแนะนำที่จัดขึ้นโดยบริษัทย่อมถือได้ว่าท่านยินยอมและตกลงที่จะปฏิบัติตามเงื่อนไขตามที่ได้กำหนดไว้ในข้อกำหนดและเงื่อนไขฉบับนี้หรือในข้อกำหนดและเงื่อนไขที่อาจมีการแก้ไขเพิ่มเติมในอนาคตโดยบริษัทและนโยบายความเป็นส่วนตัวของเรา
            เราจะถือว่าท่านได้อ่านข้อกำหนดและเงื่อนไขฉบับนี้
            และยอมรับข้อกำหนดและเงื่อนไขทั้งหมดและตกลงที่จะผูกพันตามข้อตกลงนี้
            รวมถึงรับทราบนโยบายความเป็นส่วนตัวของบริษัท
            หากท่านไม่ยินยอมที่จะปฏิบัติตามเงื่อนไขของข้อตกลงนี้จะถือว่าท่านไม่ปฏิบัติตามเงื่อนไขที่เราได้กำหนดไว้และส่งผลให้ท่านไม่ได้รับอนุญาตในการเข้าร่วมกิจกรรมที่เราจัดขึ้น
          </p>
        </Fragment>
      ),
    },
    {
      title: 'การลงทะเบียนและสร้างบัญชีสมาชิก',
      scrollTo: 'member-registration',
      content: (
        <Fragment>
          <p>
            ในการเข้าร่วมกิจกรรมการแนะนำกับเรา
            ท่านมีความจำเป็นที่จะต้องทำการสร้างบัญชีสมาชิกกับเราก่อนที่ท่านจะเข้าร่วมเพื่อให้เราสามารถทำการติดตามและตรวจสอบข้อมูลของท่านที่มีอยู่ในระบบฐานข้อมูลของเราได้
            รวมถึงเพื่อใช้ในการตรวจสอบว่าท่านได้ปฏิบัติตามข้อกำหนดและเงื่อนไขที่เรากำหนดไว้ก่อนที่เราจะดำเนินการจ่ายเงินค่าตอบแทนจากการเข้าร่วมกิจกรรมการแนะนำให้แก่ท่านต่อไป
          </p>
          <p>
            หากท่านได้ทำการสร้างบัญชีเพื่อเป็นส่วนหนึ่งในกิจกรรมการแนะนำนี้
            ท่านมีหน้าที่ในการรักษาความปลอดภัยบัญชีสมาชิกของท่านและท่านต้องรับผิดชอบต่อกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้การใช้งานบัญชีสมาชิกหรือการดำเนินการอื่นใดที่เกี่ยวข้องกับบัญชีสมาชิกนั้น
            โดยเราไม่มีหน้าที่ในการดูแลและตรวจสอบบัญชีสมาชิกใหม่ก่อนที่ท่านจะลงชื่อเข้าใช้หรือทำการเปลี่ยนแปลงในข้อมูลทางบัญชีสมาชิกของท่าน
            การให้ข้อมูลที่เป็นเท็จในขั้นตอนการสร้างบัญชีสมาชิกไม่ว่าข้อมูลประเภทใดก็ตามอาจส่งผลให้บัญชีสมาชิกของท่านถูกยุติการใช้งานบนแพลตฟอร์มของเราและอาจส่งผลให้ท่านเสียสิทธิในการได้รับรางวัลหรือค่าตอบแทนจากการเข้าร่วมกิจกรรมการแนะนำของเราถึงแม้ว่าท่านจะปฏิบัติตามเงื่อนไขและข้อกำหนดที่เราได้ระบุไว้แล้วก็ตาม
            นอกจากนี้
            ท่านต้องแจ้งให้เราทราบทันทีเมื่อบัญชีสมาชิกของท่านถูกนำไปใช้โดยไม่ได้รับอนุญาตหรือเกิดการละเมิดในความปลอดภัยต่อบัญชีสมาชิกของท่าน
          </p>
          <p>
            ทั้งนี้ ทางเราจะไม่รับผิดชอบต่อความเสียหายใด ๆ
            ที่เกิดขึ้นจากการกระทำหรือการละเว้นใด ๆ ของท่าน เราอาจระงับ
            ปิดการลงชื่อเข้าใช้งานหรือลบบัญชีสมาชิกของท่าน
            (หรืออย่างใดอย่างหนึ่ง) หากเราพิจารณาว่าท่านได้ละเมิดข้อกำหนดใด ๆ
            ของข้อกำหนดและเงื่อนไขฉบับนี้หรือการกระทำของท่านมีแนวโน้มที่จะทำลายชื่อเสียงและค่าความนิยมของเรา
          </p>
        </Fragment>
      ),
    },
    {
      title: 'เงื่อนไขในการเข้าร่วมกิจกรรมการแนะนำ',
      scrollTo: 'conditions',
      content: (
        <Fragment>
          <p>
            ในการเข้าร่วมกิจกรรมการแนะนำที่จัดขึ้นโดยบริษัทนี้
            ท่านจำเป็นจะต้องปฏิบัติตามเงื่อนไขดังต่อไปนี้ให้ครบถ้วน
          </p>
          <List>
            <li>
              ทำการสมัครเข้าร่วมกิจกรรมการแนะนำกับทางบริษัทโดยการลงทะเบียนสมาชิกตามที่เราได้กำหนดไว้ในข้อ
              2 ของข้อตกลงและเงื่อนไขฉบับนี้
            </li>
            <li>
              ท่านจะต้องทำตามขั้นตอนภายในระบบที่กำหนดโดยบริษัท
              เพื่อสร้างโค้ดที่เป็นรหัส (“รหัสผู้แนะนำ”)
              เพื่อให้ผู้ที่สนใจซื้อสินค้าหรือบริการของบริษัทนำรหัสที่ท่านได้รับจากการเข้าร่วมกิจกรรมไปกรอกในขั้นตอนการชำระเงินสินค้าหรือบริการดังกล่าวในการสั่งซื้อสินค้าหรือบริการเป็นครั้งแรกกับบริษัท{' '}
            </li>
            <li>
              การแนะนำโดยท่านจะถือว่าสำเร็จต่อเมื่อลูกค้าที่ทำการซื้อสินค้าหรือบริการของเรากรอกใช้รหัสผู้แนะนำที่ท่านได้รับและดำเนินการจนเสร็จสิ้นในขั้นตอนการชำระเงินสำหรับสินค้าหรือบริการดังกล่าวในครั้งแรกของการทำรายการกับบริษัทเท่านั้น
            </li>
            <li>
              ลูกค้าที่ใช้รหัสผู้แนะนำของท่านในการสั่งซื้อสินค้าหรือบริการของเรานั้นจะใช้ได้เพียงสำหรับการสั่งซื้อครั้งแรกเท่านั้น
            </li>
            <li>
              รหัสผู้แนะนำที่ท่านได้รับจากการสมัครเข้าร่วมกิจกรรมการแนะนำจะไม่มีวันหมดอายุ
            </li>
            <li>
              ท่านสามารถแนะนำให้ผู้อื่นทำการสั่งซื้อสินค้าหรือบริการของบริษัทได้โดยไม่มีการจำกัดจำนวนผู้ซื้อรายใหม่ในแต่ละรอบเดือน
            </li>
            <li>
              ท่านไม่สามารถใช้รหัสผู้แนะนำที่ท่านได้รับจากการเข้าร่วมกิจกรรมการแนะนำนี้เพื่อการสั่งซื้อสินค้าหรือบริการกับบริษัทผ่านบัญชีสมาชิกของท่านหรือเพื่อตัวท่านเอง
              การฝ่าฝืนของท่านย่อมถือได้ว่าท่านไม่ปฏิบัติตามเงื่อนไขที่กำหนดไว้ในข้อกำหนดและเงื่อนไขฉบับนี้
            </li>
          </List>
        </Fragment>
      ),
    },
    {
      title: 'ค่าตอบแทนจากการแนะนำและรายละเอียดส่วนลด',
      scrollTo: 'commission-and-discount',
      content: (
        <Fragment>
          <p>
            ค่าตอบแทนที่ผู้แนะนำจะได้รับสำหรับการแนะนำผู้ซื้อรายใหม่
            (“ค่าคอมมิชชั่น”)
            และส่วนลดที่ลูกค้ารายใหม่จะได้รับจากการใช้รหัสผู้แนะนำของผู้แนะนำจะเป็นไปตามเงื่อนไขดังต่อไปนี้
          </p>
          <List>
            <li>
              ผู้แนะนำที่ลูกค้ารายใหม่ได้ใช้รหัสผู้แนะนำของผู้แนะนำจนเสร็จสิ้นขั้นตอนการชำระเงินจะได้รับค่าตอบแทนในอัตราร้อยละห้า
              (5)
              ของราคาสินค้าหรือบริการที่ลูกค้ารายใหม่ผู้นั้นได้ทำการสั่งซื้อกับบริษัท
            </li>
            <li>
              ลูกค้ารายใหม่ที่ใช้รหัสผู้แนะนำของผู้แนะนำจะต้องเป็นลูกค้าที่ไม่เคยได้ทำการซื้อสินค้าหรือบริการใด
              ๆ บนแพลตฟอร์มของบริษัทมาก่อน
            </li>
            <li>
              เมื่อลูกค้าได้ใช้รหัสผู้แนะนำในขั้นตอนการชำระเงิน
              หากลูกค้าได้ทำการซื้อสินค้าหรือบริการใด ๆ
              บนแพลตฟอร์มของบริษัทเป็นครั้งแรก
              ลูกค้าจะได้รับส่วนลดของการซื้อสินค้าหรือบริการในอัตราร้อยละห้า (5)
              ของราคาสินค้าหรือบริการนั้นเป็นครั้งแรก
            </li>
            <li>
              หากสินค้าหรือบริการนั้น ๆ
              เป็นการให้บริการรูปแบบการชำระเงินแบบต่อเนื่อง (Subscription) เช่น
              การชำระค่าบริการเป็นรายเดือน
              ลูกค้าที่ใช้รหัสผู้แนะนำของผู้แนะนำจะได้รับส่วนลดจากการซื้อสินค้าหรือบริการในอัตราร้อยละห้า
              (5) ของราคาสินค้าเฉพาะในรอบบิลแรกเท่านั้น
            </li>
            <li>
              ค่าคอมมิชชั่นที่ผู้แนะนำจะได้รับจะถูกคำนวณและจ่ายโดยบริษัทเป็นรายเดือน
            </li>
            <li>
              เมื่อทางบริษัทได้ทำการตรวจสอบว่าผู้แนะนำได้ปฏิบัติตรงตามเงื่อนไขที่กำหนดไว้ในข้อตกลงและเงื่อนไขฉบับนี้เรียบร้อยแล้ว
              บริษัทจะทำการจ่ายค่าคอมมิชชั่นให้แก่ผู้แนะนำภายในวันที่ห้า (5)
              ของเดือนถัดไปผ่านการโอนเงินเข้าบัญชีธนาคารที่ผู้แนะนำได้ระบุไว้ในขั้นตอนการลงทะเบียนสร้างบัญชีสมาชิก
              ทั้งนี้
              หากบริษัทตรวจสอบแล้วพบว่าลูกค้ารายที่ใช้รหัสผู้แนะนำของผู้แนะนำเคยซื้อสินค้าหรือบริการของบริษัทมาแล้ว
              ผู้แนะนำจะไม่ได้รับค่าคอมมิชชั่นในส่วนของลูกค้ารายนั้น
            </li>
            <li>
              รหัสผู้แนะนำของผู้แนะนำจะไม่สามารถใช้ร่วมกับข้อเสนอหรือรายการส่งเสริมการขายอื่น
              ๆ ได้
            </li>
            <li>
              ลูกค้าจะต้องไม่ได้มีการสั่งซื้อหรือลงทะเบียนใช้บริการก่อนหน้านี้โดยใช้ที่อยู่อีเมลหรือนามแฝงใด
              ๆ เพื่อซื้อสินค้าหรือบริการใด ๆ บนแพลตฟอร์มของบริษัทมาก่อน
            </li>
          </List>
        </Fragment>
      ),
    },
    {
      title: 'การคุ้มครองข้อมูลส่วนบุคคล',
      scrollTo: 'privacy-policy',
      content: (
        <Fragment>
          <p>
            บริษัทจะเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลของท่านที่ท่านได้ให้แก่บริษัทด้วยความระมัดระวัง
            และเป็นไปตามมาตรฐานที่กำหนดไว้ในนโยบายความเป็นส่วนตัวของบริษัทซึ่งถือเป็นส่วนหนึ่งของข้อกำหนดและเงื่อนไขฉบับนี้
            ท่านสามารถศึกษาเพิ่มเติมเกี่ยวกับนโยบายความเป็นส่วนตัวของบริษัท
            ได้ที่
            <NextLink href="/privacy" passHref>
              <Link color="brand.400">นโยบายความเป็นส่วนตัวของบริษัท</Link>
            </NextLink>
          </p>
        </Fragment>
      ),
    },
    {
      title: 'ระยะเวลากิจกรรม',
      scrollTo: 'event-period',
      content: (
        <Fragment>
          <p>
            กิจกรรมการแนะนำนี้จะดำเนินไปอย่างต่อเนื่องนับตั้งแต่มีการประกาศรายละเอียดกิจกรรมการแนะนำโดยบริษัทจนกว่าจะมีการยกเลิกโดยบริษัท
            ทั้งนี้
            บริษัทสงวนสิทธิในการยกเลิกกิจกรรมการแนะนำโดยไม่ต้องมีการแจ้งล่วงหน้า
          </p>
        </Fragment>
      ),
    },
    {
      title: 'การต่อต้านการทุจริต',
      scrollTo: 'fraud-prevention',
      content: (
        <Fragment>
          <p>
            บริษัทขอสงวนสิทธิที่จะตรวจสอบผู้เข้าร่วมกิจกรรมการแนะนำว่ามีการฉ้อโกงหรือไม่และจะดำเนินการเพื่อยุติการกระทำดังกล่าว
            โดยการดำเนินการนี้จะขึ้นอยู่กับดุลยพินิจของทางบริษัทแต่เพียงผู้เดียว
            ซึ่งอาจรวมถึงการระงับบัญชีสมาชิก
            ยกเลิกค่าคอมมิชชั่นที่ผู้แนะนำมีสิทธิจะได้รับ
            เรียกคืนค่าคอมมิชชั่นที่ผู้แนะนำได้รับไปหากตรวจพบการทุจริตหรือไม่ปฏิบัติตามเงื่อนไขที่กำหนด
            หรือยกเลิกการใช้รหัสผู้แนะนำของผู้แนะนำ
            หากบริษัทพบกิจกรรมที่อาจก่อให้เกิดอันตราย การทุจริต
            หรือการละเมิดในเงื่อนไขของข้อกำหนดและเงื่อนไขฉบับนี้
          </p>
          <p>
            ทั้งนี้
            การเรียกคืนค่าคอมมิชชั่นที่ผู้แนะนำได้รับจะต้องกระทำผ่านช่องทางที่ได้มีการตกลงกันระหว่างผู้แนะนำและบริษัท
            หากผู้แนะนำไม่ยินยอมที่จะส่งคืนค่าคอมมิชชั่นให้แก่บริษัท
            บริษัทมีสิทธิที่จะดำเนินคดีและเรียกค่าปรับตามกฎหมายเพื่อเรียกคืนค่าคอมมิชชั่นดังกล่าวจากผู้แนะนำได้
          </p>
        </Fragment>
      ),
    },
    {
      title: 'การเปลี่ยนแปลงและการแก้ไข',
      scrollTo: 'changes-and-correction',
      content: (
        <Fragment>
          <p>
            บริษัทขอสงวนสิทธิในการใช้ดุลพินิจแต่ฝ่ายเดียวที่จะแก้ไข เปลี่ยนแปลง
            เพิ่มเติมตัดทอน
            ข้อกำหนดและเงื่อนไขฉบับนี้ตามที่บริษัทเห็นสมควรเป็นครั้งคราวโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
            หากภายหลังการแก้ไขเปลี่ยนแปลงดังกล่าวแล้ว
            ท่านยังคงเข้าร่วมกิจกรรมการแนะนำที่บริษัทได้จัดขึ้นอยู่ถือว่าท่านได้ตกลงยอมรับตามข้อกำหนดและเงื่อนไขที่ได้มีการเปลี่ยนแปลงนั้นแล้วอย่างไม่มีเงื่อนไข
            ทั้งนี้
            ท่านไม่อาจอ้างเหตุในการไม่ทราบถึงการเปลี่ยนแปลงดังกล่าวมาเป็นเหตุในการฝ่าฝืนข้อกำหนดและเงื่อนไขฉบับนี้ได้
          </p>
        </Fragment>
      ),
    },
    {
      title: 'กฎหมายที่ใช้บังคับ',
      scrollTo: 'laws',
      content: (
        <Fragment>
          <p>
            ข้อกำหนดและเงื่อนไขฉบับนี้อยู่ภายใต้บังคับของกฎหมายแห่งราชอาณาจักรไทย
            บรรดาข้อพิพาททั้งหมดที่เกิดขึ้นจากข้อกำหนดและเงื่อนไขฉบับนี้ให้อยู่ภายใต้การพิจารณาโดยศาลที่มีเขตอำนาจในราชอาณาจักรไทยหากไม่สามารถยุติข้อพิพาทดังกล่าวได้โดยการเจรจา
          </p>
        </Fragment>
      ),
    },
    {
      title: 'ติดต่อบริษัท',
      scrollTo: 'contact-us',
      content: (
        <Fragment>
          <p>
            หากท่านมีคำถามเกี่ยวกับข้อกำหนดและเงื่อนไขฉบับนี้
            ท่านสามารถติดต่อบริษัทได้ผ่านช่องทางดังต่อไปนี้
          </p>
          <Grid
            sx={{
              gap: '4px 12px',
              gridTemplateColumns: 'max-content 1fr',
              p: {
                margin: 0,
              },
            }}
          >
            <Text sx={{ gridColumn: '1/-1' }}>บริษัท เอ็นเดต้าธอธ จำกัด</Text>
            <p>สถานที่ติดต่อ:</p>
            <p>
              7 อาคารซัมเมอร์ พอยท์ ชั้นที่ 2 ซอยสุขุมวิท 69 แขวงพระโขนงเหนือ
              เขตวัฒนา กรุงเทพมหานคร 10110
            </p>

            <p>อีเมล:</p>
            <p>info@ndatathoth.com</p>

            {/*<p>เว็บไซต์: </p>
            <p>www.datawow.io</p>*/}

            <p>เบอร์โทรศัพท์: </p>
            <p>02-024-5560</p>
          </Grid>
        </Fragment>
      ),
    },
  ],
}
